import { render, staticRenderFns } from "./UsersGroup.vue?vue&type=template&id=27d1a7ec&"
import script from "./UsersGroup.vue?vue&type=script&lang=js&"
export * from "./UsersGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UsersGroup.vue"
export default component.exports